import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';

import { infoTechApi as api } from 'api/infoTech';
import { DataTable, Notifications } from 'shared';
import dayjs from 'utils/dayjsConfig';

function ITSTIckets() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [knowledgeBaseEntries, setKnowledgeBaseEntries] = useState([]);

    // Load table
    const getRows = async (kbEntries) => {
        const response = await api.getITSTickets();
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        if (response.data.rows) {
            response.data.rows.map((row) => {
                row.createdAt = dayjs(row.createdAt.date).format('MM/DD/YYYY');
                row.responseLinkedOn = row.responseLinkedOn
                    ? dayjs(row.responseLinkedOn.date).format('MM/DD/YYYY HH:mm:ss')
                    : '';
                return row;
            });
        }

        setRows(response.data.rows || []);
    };

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'fsTicketID', Header: 'Freshworks Ticket ID' },
        { accessor: 'initialTicketDesc', Header: 'Problem' },
        {
            accessor: 'itsKnowledgeBaseID',
            Header: 'Knowledge Base',
            editable: true,
            editProps: {
                options: knowledgeBaseEntries.map((entry) => ({ value: entry.id, text: entry.title })),
                type: 'select',
            },
        },
        { accessor: 'createdAt', Header: 'Created At' },
        { accessor: 'responseLinkedBy', Header: 'Response Linked By' },
        { accessor: 'responseLinkedOn', Header: 'Response Linked On' },
        {
            accessor: 'unlink',
            Header: 'Unlink',
            Cell: ({ cell: { value: initialValue }, column, editable, row, saveEdit }) => (
                <Button
                    onClick={async () => {
                        const response = await api.unlinkArticleFromTicket(row.original.id);

                        if (response.status === false) {
                            setNotification({ text: `Can't unlink entry ${response.msg}`, level: 'error' });
                            return;
                        }

                        getRows();
                    }}
                >
                    Unlink
                </Button>
            ),
        },
    ];

    useEffect(() => {
        const loadData = async () => {
            const kbResponse = await api.getKnowledgeBaseEntries();
            let kbEntries = [];
            if (kbResponse.data && kbResponse.data.rows) {
                kbEntries = kbResponse.data.rows;
                setKnowledgeBaseEntries(kbEntries);
            }
            await getRows(kbEntries);
        };
        loadData();
    }, []);

    return (
        <div>
            <h1>ITS Tickets</h1>
            <Notifications options={notification} />
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable
                    saveEdit={async ({ field, id, row, value }) => {
                        const item = {};
                        item[field] = value;

                        if (field === 'itsKnowledgeBaseID') {
                            const response = await api.updateITSTicket(id, item);

                            if (response.status === false) {
                                setNotification({ text: `Failed: ${response.msg}`, level: 'error' });
                                return;
                            }
                        }

                        await getRows(knowledgeBaseEntries);
                    }}
                />
            </div>
        </div>
    );
}

export { ITSTIckets };
